import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import Reveal from './Reveal';

const DEFAULT_FAQS = [
  { q: 'هل التجربة المجانية تحتاج بطاقة ائتمانية؟', a: 'لا. تسجّل منشأتك وتبدأ 30 يوماً كاملة بلا أي بطاقة أو التزام، وتقرر بعدها إن أردت الاستمرار.' },
  { q: 'هل بياناتي معزولة عن بقية المنشآت؟', a: 'نعم. كل منشأة لها قاعدة بيانات معزولة منطقياً بالكامل — لا أحد يرى لاعبيك أو ماليتك أو تقاريرك مهما كان.' },
  { q: 'عندي بياناتي في Excel، أنقلها كيف؟', a: 'ترفع الملف كما هو ونعرض لك معاينة لكل ما سيُنشأ (فئات، لاعبون، اشتراكات، متأخرات) قبل الحفظ، ويمكنك التراجع عن الاستيراد بالكامل.' },
  { q: 'ماذا لو احتجت باقة أكبر أو مزايا خاصة؟', a: 'تواصل معنا عبر واتساب ونرتّب لك باقة مخصصة تناسب عدد لاعبيك وفروعك واحتياجك.' },
  { q: 'هل يعمل النظام على الجوال؟', a: 'نعم، كل الشاشات مصممة للعمل من الجوال — تسجيل الحضور، متابعة الاشتراكات، والتقارير، بلا تطبيق أو تثبيت.' },
  { q: 'هل أستطيع إلغاء الاشتراك في أي وقت؟', a: 'نعم، لا عقود ملزمة. بياناتك تبقى لك ويمكنك تصديرها إلى Excel أو PDF في أي لحظة.' },
];

export const LandingFAQ = ({ landing }) => {
  const [open, setOpen] = useState(null);
  const items = Array.isArray(landing?.faqs) && landing.faqs.length ? landing.faqs : DEFAULT_FAQS;

  return (
    <section id="faq" className="mx-auto max-w-4xl px-5 py-20 md:py-28" data-testid="landing-faq">
      <Reveal>
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-bold uppercase tracking-wider text-teal-400">أسئلة شائعة</span>
          <h2 className="font-display mt-3 text-2xl font-bold text-white sm:text-3xl lg:text-4xl" data-testid="landing-faq-title">
            {landing?.faq_title || 'أسئلة يسألها الجميع قبل البدء'}
          </h2>
        </div>
      </Reveal>

      <div className="mt-10 space-y-3">
        {items.map((f, i) => {
          const isOpen = open === i;
          return (
            <Reveal key={i} delay={i * 50}>
              <div className={`overflow-hidden rounded-2xl border transition-colors ${isOpen ? 'border-teal-500/40 bg-white/[0.04]' : 'border-white/10 bg-white/[0.02]'}`}>
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-start hover:shadow-none"
                  data-testid={`landing-faq-question-${i}`}
                >
                  <span className="font-display text-sm font-bold text-white sm:text-base">{f.q}</span>
                  <ChevronDown className={`h-4 w-4 flex-shrink-0 text-teal-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <p className="px-5 pb-4 text-sm leading-relaxed text-slate-400" data-testid={`landing-faq-answer-${i}`}>{f.a}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default LandingFAQ;
